// Library import
import {useEffect, useState} from 'react';
import {Alert, Modal} from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import TrashIcon from '~/images/icon/trash.png';
import {PostApi} from '@/http';

export const DeletePostModal = ({show, postId, pathImage, items, typeParam, handleClose}) => {
    const [serverError, setServerError] = useState('');
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    //   Delete user handle
    const handleDeleteUser = async (event) => {
        event.preventDefault();

        try {
            setDisableSubmitBtn(true);
            const response = await PostApi.deletePost(postId, typeParam);

            if (response.status === 200) {
                // Delete Image in subItems
                if(items != null) {
                    items.forEach((item) => {
                        Object.keys(item).forEach((keyItem) => {
                          if(keyItem == 'sub_items') {
                            item.sub_items.forEach(async(subItem) => {
                              if(subItem.image_url && subItem.image_url != "null") {
                                await PostApi.destroyImage({path: subItem.image_url.toString()});
                              }
                            });
                          }  
                        });
                      });
                }

                // Delete image of Document
                if(pathImage && pathImage != "null") {
                    await PostApi.destroyImage({path: pathImage.toString()});
                }

                setDisableSubmitBtn(true);
                setTimeout(() => {
                    window.open(`/admin/posts?type=${typeParam}`, '_self');
                }, 1000);
            }
        } catch (error) {
            setDisableSubmitBtn(false);
            setServerError('Server error occured !');
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered animation={true} className='modal-wrapper' backdrop='static'>
            <div className='p-5'>
                <div className='modal-common-content text-center'>
                    <img src={TrashIcon} alt='Trash icon'/>
                    <p className='text my-4'>記事を削除します。 宜しいですか ?</p>

                    <div className='action-btn d-flex justify-content-center align-items-center'>
                        <button className='button primary' disabled={disableSubmitBtn}
                                onClick={(event) => handleDeleteUser(event)}>
                            削除
                        </button>
                        <button className='button outline' onClick={handleClose}>
                            キャンセル
                        </button>
                    </div>
                </div>

                {/* Server error */}
                {serverError && <Alert variant='danger'>{serverError}</Alert>}

                <div className='close-modal' onClick={handleClose}>
                    <img src={CrossIcon} alt='Cross icon'/>
                </div>
            </div>
        </Modal>
    );
};

DeletePostModal.prototype = {
    show: Proptypes.bool,
    handleClose: Proptypes.func,
    postId: Proptypes.number,
    pathImage: Proptypes.string,
    typeParam: Proptypes.string,
    items: Proptypes.any
};
